import * as types from 'modules/mediaLibrary/actionTypes';
import { createEntityAdapter, createReducer } from 'utils/ReduxUtils';

const mediaLibraryAdapter = createEntityAdapter({ selectId: ({ id }) => id });
export default createReducer(mediaLibraryAdapter.getInitialState(), {
  [types.FETCH_MEDIA_LIBRARY_SUCCESS]: (state, { payload }) => mediaLibraryAdapter.addMany(state, payload.content),
  [types.UPDATE_MEDIA_LIBRARY_SUCCESS]: (state, { payload }) => mediaLibraryAdapter.updateOne(state, payload.content),
  [types.DELETE_MEDIA_LIBRARY_SUCCESS]: mediaLibraryAdapter.removeOne,
  [types.UPLOAD_MEDIA_LIBRARY_ITEMS_SUCCESS]: (state, { payload }) => mediaLibraryAdapter.addMany(state, payload),
});
